import { fetchCurrentUser } from "../../ducks/user.duck";
// TAP PAYMENT - COMMENTED OUT (Replaced with STC Bank)
// import { onRetrieveAuthorize } from "../../util/api";
import { onRetrieveStcPayment } from "../../util/api";
import { queryOwnListings } from "../ManageListingsPage/ManageListingsPage.duck";
import { updateProfile } from "../ProfileSettingsPage/ProfileSettingsPage.duck";

// Action Types
export const ALL_LISTING_REQUEST = 'app/PromotionPaymentPage/ALL_LISTING_REQUEST';
export const ALL_LISTING_SUCCESS = 'app/PromotionPaymentPage/ALL_LISTING_SUCCESS';
export const ALL_LISTING_ERROR = 'app/PromotionPaymentPage/ALL_LISTING_ERROR';
export const PROMOTION_DRAFT_DATA_SUCCESS = 'app/PromotionPaymentPage/PROMOTION_DRAFT_DATA_SUCCESS';

export const PAYMENT_STATUS_REQUEST = 'app/PromotionPaymentPage/PAYMENT_STATUS_REQUEST';
export const PAYMENT_STATUS_SUCCESS = 'app/PromotionPaymentPage/PAYMENT_STATUS_SUCCESS';
export const PAYMENT_STATUS_ERROR = 'app/PromotionPaymentPage/PAYMENT_STATUS_ERROR';


// Initial state for the notification reducer
const initialState = {
  loading: false,
  data: [],
  promotionDraftData: null,
  error: null,

  fetchPaymentInProgress: false,
  fetchPaymentError: null,
  paymentStatus: null
};

/**
 * Notification reducer to handle different notification states.
 * @param {Object} state - The current state of the notifications.
 * @param {Object} action - The action dispatched.
 * @returns {Object} - The new state after applying the action.
 */
const PromotionPaymentPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_LISTING_REQUEST:
      return {
        ...state,
        loading: true,
        error: null, // Reset error when making a new request
      };
    case ALL_LISTING_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case ALL_LISTING_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case PROMOTION_DRAFT_DATA_SUCCESS:
      return {
        ...state,
        promotionDraftData: action.payload
      }

    case PAYMENT_STATUS_REQUEST:
      return {
        ...state,
        fetchPaymentInProgress: true,
        fetchPaymentError: null, // Reset error when making a new request
      };
    case PAYMENT_STATUS_SUCCESS:
      return {
        ...state,
        fetchPaymentInProgress: false,
        paymentStatus: action.payload,
      };
    case PAYMENT_STATUS_ERROR:
      return {
        ...state,
        fetchPaymentInProgress: false,
        fetchPaymentError: action.payload,
      };

    default:
      return state;
  }
};

export default PromotionPaymentPageReducer;

/**
 * Action to trigger a notification request.
 * @returns {Object} - The action object.
 */
export const allListingRequest = () => ({
  type: ALL_LISTING_REQUEST,
});

/**
 * Action for a successful notification.
 * @param {Object} data - The data returned from the successful request.
 * @returns {Object} - The action object with the data payload.
 */
export const allListingSuccess = data => ({
  type: ALL_LISTING_SUCCESS,
  payload: data,
});

/**
 * Action for a failed notification.
 * @param {String} error - The error message.
 * @returns {Object} - The action object with the error payload.
 */
export const allListingError = error => ({
  type: ALL_LISTING_ERROR,
  payload: error,
});

export const promotionDraftDataSuccess = data => ({
  type: PROMOTION_DRAFT_DATA_SUCCESS,
  payload: data,
});

// ///
export const paymentStatusRequest = () => ({
  type: PAYMENT_STATUS_REQUEST,
});

export const paymentStatusSuccess = data => ({
  type: PAYMENT_STATUS_SUCCESS,
  payload: data,
});

export const paymentStatusError = error => ({
  type: PAYMENT_STATUS_ERROR,
  payload: error,
});


// TAP PAYMENT - COMMENTED OUT (Replaced with STC Bank)
// STC Bank payment status check
export const checkPaymentStatus = (params, search, config) => async (dispatch, getState) => {
  const { paymentId } = params || {};
  dispatch(paymentStatusRequest());
  
  // TAP PAYMENT - COMMENTED OUT (Replaced with STC Bank)
  // Legacy Tap payment code commented out - use STC Bank instead
  
  // STC Bank payment status check
  try {
    const res = await onRetrieveStcPayment({ paymentId });
    dispatch(paymentStatusSuccess(res));
    return res;
  } catch (err) {
    console.error('[PROMOTIONS][STC][Status] Error', err);
    dispatch(paymentStatusError('Error loading STC payment status'));
    throw err;
  }
};

/**
 * Thunk action to load notifications data.
 * @returns {Function} - A function that dispatches actions based on the API response.
 */
export const loadData = () => async (dispatch, getState, sdk) => {
  dispatch(allListingRequest());
  return sdk.ownListings
    .query()
    .then(res => {
      dispatch(queryOwnListings({}))
      dispatch(allListingSuccess(res?.data?.data));
    })
    .catch(err => {
      dispatch(allListingError('Error loading data!', err));
    });
};
